import { useMeeting } from "@videosdk.live/react-sdk";
import React, { Fragment, useEffect } from "react";
import useIsMobile from "../../../hooks/useIsMobile";
import useIsTab from "../../../hooks/useIsTab";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { ChatPanel } from "./ChatPanel";
import { ParticipantPanel } from "./ParticipantPanel";
import { Dialog, Transition } from "@headlessui/react";
import { useMediaQuery } from "react-responsive";
import { useMeetingAppContext } from "../../../hooks/MeetingAppContextDef";

const SideBarTabView = ({
  height,
  sideBarContainerWidth,
  panelHeight,
  panelHeaderHeight,
  panelHeaderPadding,
  panelPadding,
  handleClose,
  activePanelSpeaker,
  showCountdown,
  isBotSpeaking,
}) => {
  const { participants } = useMeeting();
  const { sideBarMode, aiAssistants = [] } = useMeetingAppContext();

  // Calculate the total number of participants including AI bots
  const { panel, interview_id, ...others } =
    JSON.parse(sessionStorage.getItem("panelDetails") || "{}") || {};

  let totalParticipants = 0;

  if (panel === "PNLO") {
    totalParticipants = 2; // fixed for PNLO
  } else {
    // Count all string values in panelDetails (excluding panel & interview_id) + 1 for "You"
    const customUserCount = Object.values(others).filter(
      (v) => typeof v === "string" && v.trim() !== ""
    ).length;

    totalParticipants = customUserCount + 1; // +1 for "You"
  }

  return (
    <div
      className="bg-gray-800 "
      style={{
        height,
        width: sideBarContainerWidth,
        paddingTop: panelPadding,
        paddingLeft: panelPadding,
        paddingRight: panelPadding,
        paddingBottom: panelPadding,
      }}
    >
      <div
        className="bg-gray-750"
        style={{
          height: height,
          borderRadius: 10,
          overflow: "hidden",
          zIndex: 9999,
          border: "0.5px solid gray",
        }}
      >
        <>
          {sideBarMode && (
            <div
              className={`flex items-center justify-between`}
              style={{
                padding: panelHeaderPadding,
                height: panelHeaderHeight - 1,
                borderBottom: "0.5px solid gray",
                backgroundColor: "black",
              }}
            >
              <p className="text-base text-white font-semibold">
                {sideBarMode === "PARTICIPANTS"
                  ? `${
                      sideBarMode.charAt(0).toUpperCase() +
                        sideBarMode.slice(1).toLowerCase() || ""
                    } (${totalParticipants})`
                  : sideBarMode === "CHAT"
                  ? "Live Transcript"
                  : ""}
              </p>
              <button
                className="text-white"
                onClick={handleClose}
                style={{ margin: 0, padding: 0 }}
              >
                <XMarkIcon className="h-5 w-5" />
              </button>
            </div>
          )}
          {sideBarMode === "PARTICIPANTS" ? (
            <ParticipantPanel
              panelHeight={panelHeight}
              activePanelSpeaker={activePanelSpeaker}
              showCountdown={showCountdown}
              isBotSpeaking={isBotSpeaking}
            />
          ) : sideBarMode === "CHAT" ? (
            <ChatPanel panelHeight={panelHeight} />
          ) : null}
        </>
      </div>
    </div>
  );
};

export function SidebarConatiner({
  height,
  sideBarContainerWidth,
  activePanelSpeaker,
  showCountdown,
  isBotSpeaking,
}) {
  const { raisedHandsParticipants, sideBarMode, setSideBarMode } =
    useMeetingAppContext();

  const isMobile = useIsMobile();
  const isTab = useIsTab();
  const isLGDesktop = useMediaQuery({ minWidth: 1024, maxWidth: 1439 });
  const isXLDesktop = useMediaQuery({ minWidth: 1440 });

  const panelPadding = 8;
  const paddedHeight = height - panelPadding * 3.5;

  const panelHeaderHeight = isMobile
    ? 35
    : isTab
    ? 39
    : isLGDesktop
    ? 43
    : isXLDesktop
    ? 42
    : 0;

  const panelHeaderPadding = isMobile
    ? 6
    : isTab
    ? 8
    : isLGDesktop
    ? 10
    : isXLDesktop
    ? 12
    : 0;

  const handleClose = () => {
    setSideBarMode(null);
  };

  // For mobile/tablet, use the modal approach
  if (isTab || isMobile) {
    return (
      <Transition appear show={sideBarMode ? true : false} as={Fragment}>
        <Dialog
          as="div"
          className="relative"
          style={{ zIndex: 9999 }}
          onClose={handleClose}
        >
          {/* Modal content - keep existing modal code */}
        </Dialog>
      </Transition>
    );
  }

  // For desktop, render directly without conditional wrapper
  return (
    <SideBarTabView
      height={paddedHeight}
      sideBarContainerWidth={sideBarContainerWidth}
      panelHeight={paddedHeight - panelHeaderHeight - panelHeaderPadding}
      raisedHandsParticipants={raisedHandsParticipants}
      panelHeaderHeight={panelHeaderHeight}
      panelHeaderPadding={panelHeaderPadding}
      panelPadding={panelPadding}
      handleClose={handleClose}
      activePanelSpeaker={activePanelSpeaker}
      showCountdown={showCountdown}
      isBotSpeaking={isBotSpeaking}
    />
  );
}
